import {
  BACKOFFICE_MANAGER_GT_ID,
  BACKOFFICE_MANAGER_UFT_ID,
  MULTISITE_MANAGER_GT_ID,
  MULTISITE_MANAGER_UFT_ID,
  POCKETLAB_UFT_ID,
} from "../constants/auto-grouping";

export interface UserGroup {
  id: number;
  groupTemplateId: number;
}

export interface UserGroupMembership {
  id: number;
  groupId: number;
  userId?: string;
  geoPointId?: number;
  isActive: boolean;
  deletedAt?: string | null;
  membershipType: number;
}

export interface TranslatedText {
  textSlug: string;
  text: string;
  locale: { id: number; value: string };
}

export interface UserRole {
  id: number;
  nameTextId: TranslatedText;
  descTextId: TranslatedText;
}

export function getRoleFromGroups(
  groups?: UserGroup[],
  memberships?: UserGroupMembership[],
  roles?: UserRole[],
) {
  if (
    !groups ||
    !roles ||
    !memberships ||
    !groups.length ||
    !roles.length ||
    !memberships.length
  ) {
    // data not received yet
    return undefined;
  }

  // highest role is backoffice manager.
  if (
    groups.some(
      (x) =>
        x.groupTemplateId == BACKOFFICE_MANAGER_GT_ID &&
        memberships.some((y) => y.groupId == x.id && y.membershipType > 0),
    )
  ) {
    const role = roles.find((x) => x.id == BACKOFFICE_MANAGER_UFT_ID);
    if (role) {
      return role;
    }
  }

  // intermediary role is multisite manager.
  if (
    groups.some(
      (x) =>
        x.groupTemplateId == MULTISITE_MANAGER_GT_ID &&
        memberships.some((y) => y.groupId == x.id && y.membershipType > 0),
    )
  ) {
    const role = roles.find((x) => x.id == MULTISITE_MANAGER_UFT_ID);
    if (role) {
      return role;
    }
  }

  // it must be a pocket lab user then.
  const role = roles.find((x) => x.id == POCKETLAB_UFT_ID);

  return role;
}

export function getUserRoleFromGroups(
  groups?: UserGroup[],
  memberships?: UserGroupMembership[],
  roles?: UserRole[],
): string {
  // it shouldn't return missing translation.. well, just in case.
  return (
    getRoleFromGroups(groups, memberships, roles)?.nameTextId?.text ??
    "Site (missing translation)"
  );
}

export function isRoleManager(
  groups?: UserGroup[],
  memberships?: UserGroupMembership[],
  roles?: UserRole[],
) {
  const role = getRoleFromGroups(groups, memberships, roles);
  return (
    role?.id == BACKOFFICE_MANAGER_UFT_ID ||
    role?.id == MULTISITE_MANAGER_UFT_ID
  );
}
